import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import { environment } from '../../environments/environment';

/**
 * OKTA auth options
 */
export const oktaAuthOptions: OktaAuthOptions = {
  clientId: environment.OktaClientId,
  issuer: environment.OktaDomain,
  redirectUri: environment.OktaRedirectUri,
  postLogoutRedirectUri: environment.OktaPostLogoutRedirectUri,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true,
  devMode: !environment.production
};

/**
 * Factory that creates and configures OKTA
 */
export function OktaConfigFactory() {
  const oktaAuth = new OktaAuth(oktaAuthOptions);
  return {
    oktaAuth,
    onAuthRequired: (okta: OktaAuth) => {
      const triggerLogin = async () => {
        const requestedUrl = window.location.href;
        sessionStorage.setItem('app:requestedUrl', requestedUrl);
        await okta.signInWithRedirect();
      };

      triggerLogin().then(() => {
        //Success callback
      }).catch(() => {
        //Error callback
      });
    }
  }
}
